import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiBox, FiShoppingBag, FiUsers } from "react-icons/fi";
import { shopClient, type ShopDashboardStats } from "../../Pages/Shop/shopClient";
import { PanelCard } from "./dashboardShared";

/** Compact commerce pulse for the global dashboard. This replaces the inherited
 * BCC currency widget with the operational numbers APA staff need every day. */
export const ShopPulse: React.FC = () => {
	const [stats, setStats] = useState<ShopDashboardStats | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;
		shopClient.dashboard
			.stats()
			.then((value) => active && setStats(value))
			.catch(() => active && setStats(null))
			.finally(() => active && setLoading(false));
		return () => {
			active = false;
		};
	}, []);

	const values = [
		{ label: "Références", value: stats?.stock.totalSkus, icon: FiBox },
		{ label: "Unités en stock", value: stats?.stock.unitsOnHand, icon: FiShoppingBag },
		{ label: "Clients", value: stats?.customersCount, icon: FiUsers },
	];

	return (
		<PanelCard
			title="Boutique APA"
			subtitle="Catalogue et opérations"
			action={
				<Link to="/boutique" className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 hover:text-emerald-800">
					Ouvrir <FiArrowRight />
				</Link>
			}
			bodyClassName="p-5"
		>
			<div className="grid grid-cols-3 gap-3">
				{values.map(({ label, value, icon: Icon }) => (
					<div key={label} className="rounded-lg bg-slate-50 p-3">
						<Icon className="h-4 w-4 text-emerald-600" />
						<p className="mt-2 text-xl font-bold tabular-nums text-slate-900">{loading ? "…" : (value ?? "—")}</p>
						<p className="mt-0.5 text-[11px] leading-tight text-slate-500">{label}</p>
					</div>
				))}
			</div>
			<div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs font-semibold text-emerald-700">
				<Link to="/orders" className="hover:text-emerald-900">Commandes</Link>
				<Link to="/stock" className="hover:text-emerald-900">Stock</Link>
				<Link to="/returns" className="hover:text-emerald-900">Consignes</Link>
			</div>
		</PanelCard>
	);
};

export default ShopPulse;
